export enum FormSlug {
  Integrations = "integrations",
  KeyTeamMembers = "key-team-members",
  InstructionalBestPractices = "instructional-best-practices",
  MeasuringSuccess = "measuring-success",
  Communications = "communications",
  ProfessionalLearning = "professional-learning",
  ContentPromotion = "content-promotion",
}
